import { useState } from 'react';
import { isAxiosError } from 'axios';
import { Member, FetchStatus, AddedMember } from 'types/api';
import { registerModuleApi } from 'modules/RegisterModule/api';

export const useEditCompanyMember = () => {
  const [status, setStatus] = useState<FetchStatus>('idle');
  const [errors, setError] = useState<Member | null>(null);
  const [member, setMember] = useState<AddedMember | null>(null);

  const editCompanyMember = async (id: number, { name, ...rest }: Member) => {
    setStatus('loading');
    setError(null);

    try {
      const updatedMember = await registerModuleApi.updateMember(id, {
        full_name: name,
        ...rest,
      } as Partial<AddedMember>);
      setMember(updatedMember);
      setStatus('success');
    } catch (error) {
      setStatus('failed');

      if (isAxiosError(error)) {
        const errors = error?.response?.data as Record<string, [string]>;
        const objectKeys = Object.keys(errors);
        const mappedErrors = objectKeys.reduce(
          (acc, key) => {
            acc[key] = errors[key].join(' ');
            return acc;
          },
          {} as Record<string, string>
        );
        setError(mappedErrors as unknown as Member);
      } else {
        setError({ name: 'Something went wrong' } as Member);
      }
    }
  };

  return { status, errors, editCompanyMember, member };
};
